import { useEffect, useRef, useState } from 'react';
import { AnnotationLayer } from '../../components/photos/AnnotationLayer';
import { containRect } from '../../shared/photo-annotations/annotationGeometry';
import { readAnnotations, DEFAULT_REFERENCE_WIDTH } from '../../shared/photo-annotations/annotationMigrate';

export function EvidenceImage({ photo }: { photo: { image_url: string; caption: string; annotations?: unknown } }) {
  const box = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(160);
  const [aspect, setAspect] = useState<number | null>(null);
  useEffect(() => {
    if (!box.current) return;
    const observer = new ResizeObserver(([entry]) => setWidth(entry.contentRect.width));
    observer.observe(box.current);
    return () => observer.disconnect();
  }, []);
  const annotations = readAnnotations(photo.annotations, { imageAspect: aspect, screenWidth: DEFAULT_REFERENCE_WIDTH });
  return <div ref={box} style={{ position: 'relative', height: 130 }}>
    <img src={photo.image_url} alt={photo.caption || 'Inspection evidence'} style={{ objectFit: 'contain', width: '100%', height: '100%', borderRadius: 8 }} onLoad={e => setAspect(e.currentTarget.naturalWidth / e.currentTarget.naturalHeight)} />
    {!!annotations.items.length && aspect && <AnnotationLayer doc={annotations} rect={containRect(width, 130, aspect)} width={width} height={130} />}
  </div>;
}
